import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=2104af3c&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports